import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface SwitchOptionProps {
  id: string;
  label: string;
  description?: string;
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  descriptionClassName?: string;
}

export const SwitchOption = ({
  id,
  label,
  description,
  checked,
  onCheckedChange,
  disabled = false,
  className,
  labelClassName,
  descriptionClassName,
}: SwitchOptionProps) => {
  const handleLabelClick = () => {
    if (!disabled && onCheckedChange) {
      onCheckedChange(!checked);
    }
  };

  return (
    <div className={cn("flex items-start justify-between gap-4", className)}>
      <div className="space-y-1">
        <Label
          htmlFor={id}
          className={cn(
            "text-base font-medium cursor-pointer leading-none",
            labelClassName
          )}
          onClick={(e) => {
            e.preventDefault();
            handleLabelClick();
          }}
        >
          {label}
        </Label>
        {description && (
          <p className={cn("text-sm text-muted-foreground", descriptionClassName)}>
            {description}
          </p>
        )}
      </div>
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="mt-1"
      />
    </div>
  );
};
